import { formatWithoutSpaces } from "utils/format";

export const generateUrlRedirect = (item, fullTruckLoad) => {
  const redirect = window.location.pathname
  const routeSufix = (item.isOrder ? `orderId=${item.Id}` : `suggestionId=${item.Id}`) + (fullTruckLoad ? `&fullTruckLoad=true` : ``) + (`&redirectLink=${redirect}`)
  return `/loadCompositionbuilding/destino/${item.IdUnidadeNegocioDestino}/${formatWithoutSpaces(item.Destination)}/date/0000-00-00/00:00?${routeSufix}`
}
